import {useParams} from 'react-router-dom'
import {SalesPromoResult} from '../../../models/SalesPromo.model'
import {
  useSalesPromoDetailGeneralInfo,
  useSalesPromoDetailWinnerExport,
  useSalesPromoDetailWinnerResult,
} from '../../../providers/SalesPromo.provider'

export type SALES_PROMO_RESULT_ITEMS =
  | 'digital'
  | 'physical'
  | 'parking_valet'
  | 'product'
  | 'point'
export const SALES_PROMO_RESULT_ITEMS_ARRAY: {value: SALES_PROMO_RESULT_ITEMS; label: string}[] = [
  {value: 'digital', label: 'E-Voucher'},
  {value: 'physical', label: 'Physical Voucher'},
  {value: 'parking_valet', label: 'Free Parking / Valet'},
  {value: 'product', label: 'Product'},
  {value: 'point', label: 'Point'},
]

export function useSalesPromoDetailTabResult() {
  const params = useParams<{id: string}>()
  const resultDetail = useSalesPromoDetailWinnerResult(params.id)
  const generalInfo = useSalesPromoDetailGeneralInfo(params.id, true)
  const exportResultDetail = useSalesPromoDetailWinnerExport(params.id)

  return {
    generalInfo,
    resultDetail,
    exportResultDetail,
  }
}
